import { Avatar, Card, Form, Timeline } from "antd";
import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { AGGREGATION_UNIT, WEEK_DAY_OPTION } from "utils/constants";
import helper from "utils/helper";

@inject("rootStore")
@observer
class ReportInfo extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      t,
      rootStore: { reportResultStore },
    } = this.props;
    const dataCover = reportResultStore.reportDetail;

    return (
      <Card
        title={
          <div
            style={{
              textAlign: "center",
              fontSize: "20px",
              textTransform: "uppercase",
            }}
          >
            {t("report_result.report_detail_title")}
          </div>
        }
        bordered={false}
        loading={reportResultStore.loading}
        className="report-result-card"
      >
        {dataCover?.created_at && (
          <Form className="report-detail-form">
            <Form.Item label={t("report_result.report_name")}>
              {dataCover?.name}
            </Form.Item>
            <Form.Item label={t("report_result.time_zone")}>
              {dataCover?.timezone}
            </Form.Item>
            <Form.Item label={t("report_result.time_range")}>
              {dataCover?.from_time}
              {" - "}
              {dataCover?.to_time}
            </Form.Item>
            <Form.Item label={t("report_result.date_range")}>
              <Timeline className="report-time-line">
                <Timeline.Item>{dataCover?.from_date}</Timeline.Item>
                <Timeline.Item> {dataCover?.to_date}</Timeline.Item>
              </Timeline>
            </Form.Item>
            <Form.Item label={t("report_result.aggregation")}>
              {t(
                AGGREGATION_UNIT.find((e) => e.value === dataCover?.aggregation)
                  ?.text
              )}
            </Form.Item>
            <Form.Item label={t("report_result.day_of_week")}>
              {dataCover?.week_days
                ?.map((e) => {
                  return WEEK_DAY_OPTION.find((i) => i.value == e).label;
                })
                .join(", ")}
            </Form.Item>
            <Form.Item label={t("report_result.created_at")}>
              {dataCover?.created_at}
            </Form.Item>
            <Form.Item label={t("report_result.owner")}>
              {dataCover?.owner?.name}
            </Form.Item>
            <Form.Item label={t("report_result.agency")}>
              <div className="report-detail-agency">
                <div className="agency-item">
                  <Avatar style={{ backgroundColor: helper.getRandomColor() }}>
                    {helper
                      .getFirstsLetterFromWords(dataCover?.agency_name)
                      ?.substring(0, 2)}
                  </Avatar>
                  <span className="agency-name">{dataCover?.agency_name}</span>
                </div>
              </div>
            </Form.Item>
            <Form.Item
              style={{ display: "flex" }}
              label={t("report_result.selected_intersection")}
            >
              <span style={{ fontSize: "20px" }}>
                {reportResultStore.resultData?.length}
              </span>
            </Form.Item>
          </Form>
        )}
      </Card>
    );
  }
}

export default withTranslation()(ReportInfo);
